import { createKeyedDataAsyncSlice } from '../../createKeyedDataAsyncSlice';
import { postCommentForClientOrderAsync } from '../../../API/clientPortal/clientOrderAPI';

export const { slice: postClientOrderCommentSlice, asyncAction: postClientOrderCommentAction } =
  createKeyedDataAsyncSlice(
    'postClientOrderComment',
    postCommentForClientOrderAsync,
    ({ orderId }) => `${orderId}`
  );
